import { App } from 'hydra-data-types';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Color } from '../../config/Color';
import { PapScreenName } from '../../config/FlowTypes';
import { useAppStore } from '../../store/Store';
import { InsuranceSelectors } from '../../util/InsuranceSelectors';
import { Environment } from '../../util/Environment';
import { useFlowNavigator } from '../flows/FlowNavigation';
import { BodyXS } from '../styles/Typography';

export const PatientAssistanceCta: FunctionComponent = () => {
  const navigation = useFlowNavigator();
  const hasCompletedPap = useAppStore((state) => state.pap.scoreResult !== undefined);
  const isPapReferral = useAppStore((state) => state.referral.isPapReferral);
  const hasInsuranceCoverage = useAppStore(InsuranceSelectors.getHasInsuranceCoverage);

  if (
    hasInsuranceCoverage ||
    Environment.APP !== App.Nerva ||
    hasCompletedPap === true ||
    isPapReferral === true
  ) {
    return null;
  }

  return (
    <CtaContainer>
      <CtaBody>Worried about the cost?</CtaBody>
      <CtaLink onClick={() => navigation.goTo(PapScreenName.PapPublicAssistance)}>
        See if you qualify for financial support
      </CtaLink>
    </CtaContainer>
  );
};

const CtaContainer = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing._16px} 0;
  border: 1px solid ${Color.decorative.default};
  border-radius: 10px;
  margin-top: ${({ theme }) => theme.spacing._12px};
`;

const CtaBody = styled(BodyXS)`
  margin-bottom: ${({ theme }) => theme.spacing._8px};
`;

const CtaLink = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${Color.content.accent};
  text-decoration: underline;
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-family: ${({ theme }) => theme.font.primary};
  padding: 0;
`;
